<template>
  <div class="vd_wrap">
    <!-- <el-divider></el-divider> -->
    <!-- <el-form
      ref="mqcdForm"
      :model="mqcdForm"
      :rules="rules"
      label-width="120px"
      size="mini"
    > -->
    <el-row>
      <el-col :md="8">
        <el-form-item label="物料图片" prop="imge_id" :rules="!disableMtrlAdd ? [{ required: true, message: ' ' }] : [{ required: false }]">
          <el-upload
            :disabled="disableMtrlAdd"
            class="avatar-uploader"
            :action="uploadUrl"
            :data="dataBody"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <imgPopover v-if="mqcdForm.imge_id" :imgeUrl="mqcdForm.imge_url" :imgeUrlO="mqcdForm.imge_urlO"></imgPopover>
            <i v-else class="el-icon-plus avatar-uploader-icon vg_pointer"></i>
          </el-upload>
          <span>仅支持jpg、png、jpeg格式且大小不能超过10MB</span>
        </el-form-item>
      </el-col>
      <el-col :md="8">
        <el-form-item label="安全库存" prop="mdrl_stock_limit">
          <el-input
            :disabled="disableMtrlAdd"
            v-model="mqcdForm.mdrl_stock_limit"
            @input="mqcdForm.mdrl_stock_limit = helper.keepTNum(mqcdForm.mdrl_stock_limit)"
            maxlength="7"
            show-word-limit
            placeholder="请填写库存警告数量"
          ></el-input>
        </el-form-item>
        <el-form-item label="物料单价" prop="mdrl_prod_price">
          <!-- :disabled="disableMtrlAdd" -->
          <el-input
            v-model="mqcdForm.mdrl_prod_price"
            @input="mqcdForm.mdrl_prod_price = helper.keepTNum1(mqcdForm.mdrl_prod_price)"
            @blur="mqcdForm.mdrl_prod_price = helper.calcPrice(mqcdForm.mdrl_prod_price, 7, 1000000)"
            maxlength="11"
            show-word-limit
            placeholder="请填写物料单价"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="物料单位" prop="mdrl_unit">
          <el-select :disabled="disableMtrlAdd" v-model="mqcdForm.mdrl_unit" placeholder="请选择物料单位" clearable>
            <el-option v-for="item in mdrlTypeGroupOpt" :key="item.id" :label="item.param1" :value="item.param1"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="8">
        <el-form-item label="物料成分" prop="mdrl_comp">
          <el-select :disabled="disableMtrlAdd" v-model="mqcdForm.mdrl_comp" placeholder="请选择物料成分" clearable filterable>
            <el-option v-for="item in compType" :key="item.id" :label="item.param1" :value="item.param1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他备注" prop="mdrl_remark">
          <el-input
            :disabled="disableMtrlAdd"
            type="textarea"
            rows="1"
            v-model="mqcdForm.mdrl_remark"
            maxlength="150"
            show-word-limit
            placeholder="请填写物料备注"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="物料规格"
          prop="mdrl_spec"
          :rules="mqcdForm.mdrl_type !== 0 ? [{ required: true, message: ' ' }] : [{ required: false }]"
        >
          <el-input
            :disabled="disableMtrlAdd"
            type="textarea"
            rows="1"
            v-model="mqcdForm.mdrl_spec"
            maxlength="50"
            show-word-limit
            placeholder="请填写物料规格"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- </el-form> -->
  </div>
</template>

<script>
import { get } from '@api/request';
import { optnAPI } from '@api/modules/optn';
import { suppAPI } from '@api/modules/supp';
import { colrAPI } from '@/api/modules/colr.js';
import { imgeAPI } from '@api/modules/imge';
import helper from '@assets/js/helper';
import imgPopover from '@/views/component/imgPopover';

export default {
  name: 'mdrlAddMain',
  components: {
    imgPopover
  },
  props: {
    mqcdForm: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    },
    disableMtrlAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      uploadUrl: helper.modePrepend(imgeAPI.uploadImage),
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      mdrlType: [
        { id: 1, label: '钢材' },
        { id: 2, label: '辅材' }
      ],
      mdrlTypeGroupOpt: [],
      suppType: [],
      compType: [],
      optnColorList: []
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMtrlType();
      this.getCompType();
      this.getSuppsList();
      this.getOptnColor();
    },
    getImgId() {},
    // 商户下拉框下拉
    suppChange() {
      this.getSuppsList();
    },
    //获取颜色大类option
    getOptnColor() {
      get(optnAPI.getAllContent, { perm_id: 10010 })
        .then(res => {
          if (res.data.code === 0) {
            this.optnColorList = res.data.data;
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch(res => {
          this.$message.error(res.data.msg);
        });
    },
    // 获取成分
    getCompType() {
      get(optnAPI.getAllContent, { perm_id: 10008 })
        .then(res => {
          if (res.data.code === 0) {
            this.compType = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取单位
    getMtrlType() {
      get(optnAPI.getAllContent, { perm_id: 10005 })
        .then(res => {
          if (res.data.code === 0) {
            this.mdrlTypeGroupOpt = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取供应商信息
    getSuppsList() {
      get(suppAPI.getSuppsV1)
        .then(res => {
          if (res.data.code === 0) {
            this.suppType = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //同步颜色 大类
    clickSyncColor() {
      get(colrAPI.getColrClassByPantone, {
        colr_pantone: this.mqcdForm.mdrl_color + 'C'
      })
        .then(res => {
          if (res.data.code === 0) {
            this.mqcdForm.colr_class = res.data.data.form.colr_class;
            //  this.$message.success('同步'+res.data.msg)
            return;
          } else if (res.data.code === 2) {
            this.mqcdForm.colr_class = null;
            this.$message.warning('未匹配到该颜色大类');
            return;
          }
          this.$message.warning(res.data.msg);
        })
        .catch(res => {
          this.$message.warning(res.data.msg);
        });
    },
    // 成功上传
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        let updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        let urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.mqcdForm.imge_id = res.data.imge_id;
        this.mqcdForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.mqcdForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      } else {
        let mg = res.msg;
        let tp = 'error';
        this.$message({ message: mg, type: tp });
      }
    },
    //表单重置
    resetForm(formName = 'mqcdForm') {
      this.$refs[formName].resetFields();
    },
    // 上传头像前
    beforeAvatarUpload() {},
    mdrlNoInput() {
      this.mqcdForm.mdrl_no = this.helper.keepEnglish(this.mqcdForm.mdrl_no).toUpperCase();
      this.mqcdForm.mdrl_no = this.mqcdForm.mdrl_no.substr(0, 2);
    },
    typeChange() {
      if (this.mqcdForm.mdrl_type != 0) {
        this.mqcdForm.mdrl_color = '';
      }
    }
  }
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader ::v-deep .el-upload--text {
  width: 136px;
  height: 136px;
}
.avatar-uploader .el-upload:hover {
  border-color: $color-primary;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: $color-uploader-icon;
  width: 136px;
  height: 136px;
  line-height: 136px;
  text-align: center;
}
.avatar {
  width: 136px;
  height: 136px;
  display: block;
}

.vd_bortop {
  border-top: #dcdfe6 solid 1px;
  padding-top: 20px;
}
.vd_cussor {
  cursor: default;
}
::v-deep .mdrlNo .el-input-group__append {
  width: 70%;
  padding: 0;
}
::v-deep .mdrlcolor .el-input-group__append {
  width: 70%;
  padding: 0;
}
::v-deep .el-input-group__append {
  color: #000000;
}
.vd_color_red {
  color: red;
}
.vd_wrap {
  margin-top: 2px;
}
::v-deep .itemBtn .el-form-item__content {
  display: flex;
}
</style>
